(ns ui.editor2.sticker
  (:require [storrito.editor.poll-v2-sticker :as poll-v2-sticker]
            [storrito.editor.sticker :as sticker]
            [storrito.editor.icon-sticker :as icon-sticker]
            [storrito.editor.music-sticker :as music-sticker]
            [renderer6.music-sticker-constants :as constants]
            [storrito.editor.sticker-design :as sticker-designs]
            [storrito.editor.countdown-sticker :as countdown-sticker]
            [storrito.editor.question-sticker :as question-sticker]
            [storrito.editor.quiz-sticker :as quiz-sticker]
            [storrito.editor.emoji-slider-sticker :as emoji-sticker]
            [cljs-time.coerce :as tc]
            [ui.editor2.extension-points :as extension-points]
            [ui.editor2.common :as common]
            ))

(defn render
  [fabric-object]
  (let [target-canvas (js/document.createElement "canvas")
        width (.-width fabric-object)
        height (.-height fabric-object)]
    (set! (.-width target-canvas)
          width)
    (set! (.-height target-canvas)
          height)

    (let [fabric-canvas (js/fabric.StaticCanvas. target-canvas)]
      (set! fabric-canvas.preserveObjectStacking
            true)
      (.add fabric-canvas
            fabric-object)

      ;; Force immediate rendering
      (.renderAll fabric-canvas)

      {:url (.toDataURL fabric-canvas
                        #js {:format "png"})
       :width width
       :height height})))

(defn render-emoji-sticker
  [params]
  (render
    (emoji-sticker/slider-sticker (merge
                                    {:top 0
                                     :left 0}
                                    params))))

(comment
  (render-emoji-sticker
    {:question "",
     :background-color "#70c04f",
     :text-color "#ffffff",
     :emoji "😎"})
  )

(defn render-poll-sticker
  [params]
  (render
    (poll-v2-sticker/sticker (merge
                               {:top 0
                                :left 0}
                               params))))

(comment
  (render-poll-sticker
    {:question "THIS IS A RATHER LONG QUESTION AND I HAD SOME MICRO SD CARDS"
     :tallies [{:text "Yes"
                :font_size 42}
               {:text "No"
                :font_size 42}]
     :color "green"})
  )

(defn render-hashtag-sticker
  [params]
  (render
    (sticker/create-sticker params)))

(comment

  (render-hashtag-sticker
    {:text (str "#" "test")
     :scaleX 1
     :scaleY 1
     :top 0
     :left 0
     :type "hashtag"
     :design storrito.editor.sticker-design/default-hashtag-design})

  )

(defn render-mention-sticker
  [params]
  (render
    (sticker/create-sticker params)))

(comment
  (render-mention-sticker
    {:text "@maxx80000"
     :user-id 123
     :type "usertag"
     :design storrito.editor.sticker-design/default-mention-design})

  )

(defn render-location-sticker
  [params]
  (render
    (icon-sticker/icon-sticker
      (merge {:top 0
              :left 0
              :scaleX 1
              :scaleY 1}
             params))))

(comment
  (render-location-sticker
    {:location {:external_id "115735848437200"
                :external_id_source "facebook_places"
                :name "Cologne Germany"
                :address "4.8mi"
                :lat 50.939900337381
                :lng 6.9594646597893}
     :design {:icon-props {:src "/img/location-v2.svg"
                           :scaleX 0.2
                           :scaleY 0.2
                           :left 20}
              :text-props {:fill "#7437fa"}
              :opacity 1.0}})
  )

(defn render-countdown-sticker
  "A countdown without `:end_ts` (an API story whose `<insta-countdown>`
   has no `end-time`) gets the default end of `countdown-sticker`, as in
   `insta.components`; an `:end_ts nil` would bypass that default."
  [params]
  (render
    (countdown-sticker/countdown-sticker
      (merge
        {:top 0
         :left 0
         :scaleX 1
         :scaleY 1}
        (if (:end_ts params)
          (update params
                  :end_ts
                  tc/from-date)
          (dissoc params :end_ts))))))

(comment
  (render-countdown-sticker
    {:end_ts #inst "2025-03-12T15:40:56.705-00:00"
     :start_background_color "#ca2ee1"
     :end_background_color "#5eb1ff"
     :digit_color "#7e0091"
     :digit_card_color "#ffffffcc"
     :text_color "#ffffff"
     :text "COUNTDOWN🎉"})
  )

(defn render-question-sticker
  [params]
  (render
    (question-sticker/question-sticker
      (merge {:top 0
              :left 0
              :scaleX 1
              :scaleY 1}
             params))))

(comment
  (render-question-sticker
    {:question "Question?"
     :background-color "#a207ba"
     :text-color "#ffffff"})
  )

(defn render-quiz-sticker
  [params]
  (render
    (quiz-sticker/quiz-sticker
      (merge {:top 0
              :left 0
              :scaleX 1
              :scaleY 1}
             params))))

(comment
  (render-quiz-sticker
    {:text_color "#ffffff"
     :start_background_color "#262626"
     :end_background_color "#262626"
     :question "GUESS MY FAVORITE..."
     :options ["A" "B"]
     :correct_answer 0})
  )

(defn render-link-sticker
  [params]
  (render
    (icon-sticker/icon-sticker
      (merge {:top 0
              :left 0
              :scaleX 1
              :scaleY 1}
             params))))

(comment
  (render-link-sticker
    {:text "Google",
     :link "https://google.com",
     :scaleX 1,
     :scaleY 1,
     :top 0,
     :left 0,
     :type "link",
     :design (first sticker-designs/new-link-designs)})
  )

(defn render-music-sticker
  [params]
  (let [title (get-in params
                      [:track :title])
        artist (get-in params
                       [:track :display_artist])]
    (render
      (case (:display-type params)
        "MUSIC_OVERLAY_SIMPLE"
        (music-sticker/simple-sticker {:title title
                                       :artist artist
                                       :cover-img (:cover-img params)})

        "MUSIC_OVERLAY_ALBUM_ART"
        (music-sticker/album-art-sticker {:title title
                                          :artist artist
                                          :cover-img (:cover-img params)})

        "MUSIC_VINYL"
        (music-sticker/vinyl-sticker {:title title
                                      :artist artist
                                      :cover-img (:cover-img params)})

        ;; else, the invisible design (no display type set), whose faint
        ;; placeholder is not baked into the story media:
        (icon-sticker/icon-sticker
          {:top 0
           :left 0
           :scaleX 1
           :scaleY 1
           :text (str title
                      " – "
                      artist)
           :design (:design params)})))))

(comment
  (render-music-sticker
    {:track {:title "Never Gonna Give You Up"
             :display_artist "Rick Astley"}
     :design sticker-designs/invisible-music-design})
  )

(defn render-text-sticker
  [params]
  (render (js/fabric.IText. (:text params)
                            ;; Remove any object transforms from the params
                            ;; Otherwise it will mess with the set values from the
                            ;; `render` function
                            (clj->js (dissoc params
                                             :top
                                             :scaleY
                                             :scaleX
                                             :left
                                             :height
                                             :width
                                             :angle)))))

(defn composition-sticker
  [params]
  [:img
   {:src (get-in params
                 [:clip
                  :clip/asset
                  :asset/uri])
    ;; If Moveable is temporarily not intercepting the gesture, the browser
    ;; must not start a native image drag that can be dropped back onto the
    ;; editor as a duplicate sticker image.
    :draggable "false"}])

(def stickers
  {:poll-sticker render-poll-sticker
   :hashtag-sticker render-hashtag-sticker
   :mention-sticker render-mention-sticker
   :location-sticker render-location-sticker
   :countdown-sticker render-countdown-sticker
   :question-sticker render-question-sticker
   :quiz-sticker render-quiz-sticker
   :link-sticker render-link-sticker
   :emoji-slider-sticker render-emoji-sticker
   :music-sticker render-music-sticker
   :text-sticker render-text-sticker
   })

(doseq [sticker (keys stickers)]
  (defmethod extension-points/composition-asset
    sticker
    [params]
    (composition-sticker params)))

(defn animation-video
  "An autoplaying, looping video with alpha, positioned over the
   rasterized sticker image. `x`, `y`, `w` and `h` are in pixels of the
   sticker's local coordinate system (`aw`/`ah` = the rasterized
   asset's dimensions)."
  [{:keys [src x y w h aw ah]}]
  [:video
   {:style {:position "absolute"
            :left (str (* 100 (/ x aw)) "%")
            :top (str (* 100 (/ y ah)) "%")
            :width (str (* 100 (/ w aw)) "%")
            ;; Undo Tailwind's `video {max-width: 100%}` preflight,
            ;; which would clamp frames wider than the sticker:
            :max-width "none"
            :height (str (* 100 (/ h ah)) "%")
            :pointer-events "none"}
    :src src
    :autoplay true
    :loop true
    :muted true
    :playsinline true
    :preload "auto"
    :draggable "false"}])

(defn vinyl-overlays
  "The spinning cover label plus the record video (whose label area is
   transparent) layered above it, so the record's groove annulus covers
   the label's edge."
  [{:keys [aw ah data]}]
  (let [label (* (:label-ratio constants/vinyl) aw)
        disc-frame (* (:disc-frame-ratio constants/vinyl) aw)]
    (list
      [:img
       {:class ["animate-spin"]
        :style {:position "absolute"
                :left (str (* 100 (/ (- 1 (:label-ratio constants/vinyl)) 2)) "%")
                :top (str (* 100 (/ (- (/ aw 2) (/ label 2))
                                    ah))
                          "%")
                :width (str (* 100 (:label-ratio constants/vinyl)) "%")
                :height (str (* 100 (/ label ah)) "%")
                :border-radius "50%"
                :object-fit "cover"
                :animation-duration (str (:rotation-seconds constants/vinyl) "s")
                :pointer-events "none"}
        :src (:cover-blob-uri data)
        :draggable "false"}]
      (animation-video {:src (:disc-uri constants/vinyl)
                        :x (/ (- aw disc-frame) 2)
                        :y (/ (- aw disc-frame) 2)
                        :w disc-frame
                        :h disc-frame
                        :aw aw
                        :ah ah}))))

(defn music-overlays
  "The animated parts of the music sticker per display type, layered
   over the rasterized sticker exactly like renderer6 bakes them into
   the story media (WYSIWYG). In browsers that cannot play VP9 with
   alpha (Safari) only the animated part is missing from the
   composition."
  [{:keys [aw ah data] :as params}]
  (case (:display-type data)
    "MUSIC_VINYL"
    (when (seq (:cover-blob-uri data))
      (vinyl-overlays params))

    "MUSIC_OVERLAY_ALBUM_ART"
    (let [badge (* (:badge-ratio constants/album-art) aw)
          inset (* (:badge-inset-ratio constants/album-art) aw)]
      (animation-video {:src (:uri constants/waveform)
                        :x inset
                        :y (- aw inset badge)
                        :w badge
                        :h badge
                        :aw aw
                        :ah ah}))

    "MUSIC_OVERLAY_SIMPLE"
    ;; The card width varies with the text length, so the thumbnail
    ;; geometry is relative to the fixed card height:
    (let [inset (* (:thumb-inset-ratio constants/simple) ah)
          thumb (- ah (* 2 inset))]
      (animation-video {:src (:uri constants/waveform)
                        :x inset
                        :y inset
                        :w thumb
                        :h thumb
                        :aw aw
                        :ah ah}))

    nil))

(defn music-composition
  "The music sticker with its animated parts: the base image is the
   rasterized sticker, the animation overlays sit exactly on top of
   it."
  [params]
  (let [asset (get-in params [:clip :clip/asset])
        ;; The rasterized sticker can be a pixel wider than the nominal
        ;; sticker width (FabricJS group border), so use its actual
        ;; dimensions for sub-pixel exact overlay positions:
        aw (:asset/width asset)
        ah (:asset/height asset)]
    [:div
     {:style {:position "relative"
              :display "inline-block"}}
     [:img
      {:src (:asset/uri asset)
       :draggable "false"}]
     (when (and aw ah)
       (music-overlays {:aw aw
                        :ah ah
                        :data (:asset/data asset)}))]))

;; The music sticker gets its animated parts in the composition:
(defmethod extension-points/composition-asset
  :music-sticker
  [params]
  (if (get-in params [:clip :clip/asset :asset/width])
    (music-composition params)
    (composition-sticker params)))

(doseq [sticker (keys stickers)]
  (defmethod extension-points/asset-thumbnail
    sticker
    [params]
    (:asset/uri (:asset params))))

(defn load-all-fonts*
  "Tries to load all available fonts, so that they are ready when a sticker
   rendering uses one of them.

   Uses `js/Promise.allSettled` instead of `js/Promise.all` since the whole
   stickers rendering should not fail just because a single or handful of fonts
   cannot be loaded."
  []
  (js/Promise.allSettled
    (map (fn [font-face]
           (.load font-face))
         (js/Array.from (js/document.fonts.values)))))

(def load-all-fonts
  (memoize load-all-fonts*))

(defn prepare-sticker
  [{:keys [asset]}]
  (let [result (when-let [render-fn (get stickers
                                         (:asset/type asset))]
                 (render-fn
                   (:asset/data asset)))
        tx [{:asset/uuid (:asset/uuid asset)
             :asset/width (:width result)
             :asset/height (:height result)
             :asset/uri (:url result)}]]
    {:tx tx}
    ))

(defn prepare-sticker!
  [{:keys [store asset]}]
  ;; First loads all fonts to ensure that the poll-sticker & co looks correct:
  (.then (load-all-fonts)
         (fn []
           (let [{:keys [tx]} (prepare-sticker {:asset asset})]
             (swap! store
                    common/transact
                    tx)))))

(doseq [sticker (keys stickers)]
  (defmethod extension-points/prepare-asset!
    sticker
    [params]
    (prepare-sticker! params)))

(defn load-cover-image
  "Loads the cover artwork for the FabricJS rendering. Resolves to nil
   when there is no cover or it fails to load."
  [url]
  (js/Promise.
    (fn [resolve _reject]
      (if-not url
        (resolve nil)
        (let [img (js/Image.)]
          ;; The /blob/ endpoint redirects to Google Cloud Storage, which
          ;; is cross-origin. Without a CORS-mode load the image would
          ;; taint the FabricJS canvas, whose toDataURL would then throw
          ;; a SecurityError:
          (set! (.-crossOrigin img) "anonymous")
          (set! (.-onload img)
                (fn [] (resolve img)))
          (set! (.-onerror img)
                (fn [] (resolve nil)))
          (set! (.-src img) url))))))

;; The music sticker needs its own preparation: the native Instagram
;; visuals include the cover artwork, which must be loaded before the
;; FabricJS rendering:
(defmethod extension-points/prepare-asset!
  :music-sticker
  [{:keys [store asset]}]
  (.then (js/Promise.all
           (into-array
             [(load-all-fonts)
              (load-cover-image (get-in asset
                                        [:asset/data :cover-blob-uri]))]))
         (fn [results]
           (let [cover-img (aget results 1)
                 result (render-music-sticker (assoc (:asset/data asset)
                                                     :cover-img cover-img))
                 tx [{:asset/uuid (:asset/uuid asset)
                      :asset/width (:width result)
                      :asset/height (:height result)
                      :asset/uri (:url result)}]]
             (swap! store
                    common/transact
                    tx)))))
